const RIDERS_WAY_START_URL = import.meta.env.DEV
  ? 'http://127.0.0.1:4180/start'
  : 'https://riderswayapp.com/start'

const ATTRIBUTION_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'fbclid',
  'gclid',
  'gbraid',
  'wbraid',
  'msclkid',
] as const

export function buildRidersWayStartUrl(placement: string): string {
  const destination = new URL(RIDERS_WAY_START_URL)

  if (typeof window !== 'undefined') {
    const current = new URLSearchParams(window.location.search)
    for (const key of ATTRIBUTION_KEYS) {
      const value = current.get(key)
      if (value) destination.searchParams.set(key, value)
    }
  }

  if (!destination.searchParams.has('utm_source')) {
    destination.searchParams.set('utm_source', 'advantage_horsemanship')
  }
  if (!destination.searchParams.has('utm_medium')) {
    destination.searchParams.set('utm_medium', 'referral')
  }
  if (!destination.searchParams.has('utm_campaign')) {
    destination.searchParams.set('utm_campaign', 'riders_way_trial')
  }
  if (!destination.searchParams.has('utm_content')) {
    destination.searchParams.set('utm_content', placement)
  }

  destination.searchParams.set('ah_placement', placement)
  return destination.toString()
}
